import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M32.6656 9.48309V13.5537H29.7022V11.1944L19.3291 5.20553V8.26074L27.1334 12.7368V23.3318L19.3291 27.8079V30.8715L29.7022 24.8827V22.5072H32.6656V26.5939L17.8475 35.1491L3.0293 26.5939V9.48309L17.8475 0.927979L32.6656 9.48309ZM5.99267 11.1944V24.8827L16.3658 30.8715V27.751L8.65984 23.3318V12.7368L16.3658 8.31766V5.20553L5.99267 11.1944ZM20.3115 12.1231L15.9072 16.7997V12.7524L12.5519 12.1231V24.287H15.9072V20.3652L18.0887 18.0375L20.7733 24.287H24.3382L21.2138 17.9955H18.1307L23.6675 12.1231H20.3115Z",
      fill: "#4365FF"
    }, null, -1)
  ]))]))
}
export default { render: render }